// @ts-ignore
import * as ramda from 'ramda';

export function reorder(
    currentList: Array<string>,
    currentItem: string,
    newItem: string
): Array<string> {
    if (!currentList.includes(currentItem)) {
        return currentList;
    }
    // @ts-ignore
    const currentIndex: number = ramda.findIndex((a) => a === currentItem)(currentList);
    // @ts-ignore
    const newIndex: number = ramda.findIndex((b) => b === newItem)(currentList);
    const fieldsMinusMoved: Array<string> = ramda.remove(currentIndex, 1, currentList);

    return ramda.insert(newIndex, currentItem, fieldsMinusMoved);
}
